import {Component, OnInit, Input, ChangeDetectorRef, HostListener, OnDestroy} from '@angular/core';
import { LabelModel } from '../label.model';
import { Subject } from 'rxjs';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { takeUntil } from 'rxjs/operators';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'abw-label-design',
    templateUrl: './label-design.component.html',
    styleUrls: ['./label-design.component.scss']
})
export class LabelDesignComponent implements OnInit, OnDestroy {
    isComponentSelected = false;
	@Input() model: LabelModel;
    @Input() value: any;
    onComplete = new Subject();
    cleanLabel: string;

    constructor(
        private _workflowComponentsService: WorkflowComponentsService,
        private _cdf: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
        this.cleanLabel = this.model.label.replace(/(<([^>]+)>)/gi, "");
        this._workflowComponentsService.workflowDesignerComponentSelected$.pipe(takeUntil(this.onComplete)).subscribe(_selectedComponent => {
            this.isComponentSelected = _selectedComponent != null && _selectedComponent.GUID == this.model.additional.GUID;
            this._cdf.detectChanges();
        });
    }

    @HostListener("click") onClick(){
        const base_component = this.model.additional as Model_WorkflowComponent;
        base_component.PROPERTIES = this.value;
        this._workflowComponentsService.workflowDesignerComponentSelected$.next(base_component);
    }

    ngOnDestroy() {
        this.onComplete.next();
        this.onComplete.complete();
    }
}